import React from 'react';

export default function NavBar(){

	return(
	<nav>
		<ul>
		<li><a href="/">Home</a></li>
		<li><a href="/tea_products">Tea Products</a>
		<div className="dropdown">
				<a href="/tea_bags">Tea Bags</a>
				<a href="/iced_tea">Iced Tea</a>
			</div>
		</li>
		<li><a href="/accessories">Accessories</a>
		<div className="dropdown">
				<a href="/ceramics">Ceramics</a>
				<a href="/tools">Tea Tools</a>
			</div>
		</li>
		</ul>
		<ul>
		<li><a href="/blends">Blends</a>
		<div className="dropdown">
				<a href="/matcha">Matcha</a>
				<a href="/loose">Loose Tea</a>
			</div>
		</li>
		<li><a href="/blog">Articles</a></li>
		<li><a href="/contact">Contact</a></li>
		<li><a href="/info">Info</a></li>
		</ul>
	</nav>
		
	)
}